import { Navigate, Route, BrowserRouter as Router, Routes, useLocation, useParams } from "react-router-dom";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import { ThemeProvider, useTheme } from "@/context/ThemeContext";
import { Toaster } from "@/components/ui/sonner";
import Layout from "@/components/Layout";
import Login from "@/pages/Login";
import Comercial from "@/pages/Comercial";
import ClientePage from "@/pages/ClientePage";
import CalendarioEditorial from "@/pages/CalendarioEditorial";
import Producao from "@/pages/Producao";
import Financeiro from "@/pages/Financeiro";
import Configuracoes from "@/pages/Configuracoes";
import EditorialPublic from "@/pages/EditorialPublic";
import { ConnectionNotice } from "@/components/ConnectionNotice";

function Protected({ children }) {
  const { user } = useAuth();
  if (user === null)
    return (
      <div className="min-h-screen bg-[#09090B] flex flex-col items-center justify-center gap-6 px-5">
        <div className="flex items-center gap-3">
          <span className="w-2 h-2 rounded-full bg-[#F43F5E] animate-pulse" />
          <span className="font-mono text-xs tracking-widest text-[#71717A] uppercase">Carregando estúdio…</span>
        </div>
        <div className="w-full max-w-xl"><ConnectionNotice /></div>
      </div>
    );
  if (user === false) return <Navigate to="/login" replace />;
  return children;
}

function CalendarioLegado() {
  const location = useLocation();
  const destino = location.search.includes("abrir=postagem:") ? "/calendario-editorial" : "/producao?view=agenda";
  if (destino.includes("?")) return <Navigate to={destino} replace />;
  return <Navigate to={`${destino}${location.search}`} replace />;
}

function ClienteLegado() {
  const { id } = useParams();
  return <Navigate to={`/producao/clientes/${id}`} replace />;
}

function AppToaster() {
  const { mode } = useTheme();
  return (
    <Toaster
      theme={mode}
      position="top-right"
      toastOptions={{
        style: {
          background: "var(--studio-card)",
          border: "1px solid var(--studio-border)",
          color: "var(--studio-text)",
        },
      }}
    />
  );
}

export default function App() {
  return (
    <ThemeProvider>
      <AuthProvider>
        <Router>
          <Routes>
          <Route path="/login" element={<Login />} />
          <Route path="/editorial/:slug/:token" element={<EditorialPublic />} />
          <Route path="/editorial/:token" element={<EditorialPublic />} />
          <Route element={<Protected><Layout /></Protected>}>
            <Route path="/" element={<Navigate to="/producao?view=hoje" replace />} />
            <Route path="/clientes" element={<Navigate to="/producao?view=clientes" replace />} />
            <Route path="/clientes/:id" element={<ClienteLegado />} />
            <Route path="/producao" element={<Producao />} />
            <Route path="/producao/clientes/:id" element={<ClientePage />} />
            <Route path="/rotina-estudio" element={<Navigate to="/producao?view=agenda" replace />} />
            <Route path="/calendario-editorial" element={<CalendarioEditorial />} />
            <Route path="/calendario" element={<CalendarioLegado />} />
            <Route path="/agenda" element={<Navigate to="/producao?view=agenda" replace />} />
            <Route path="/projetos" element={<Navigate to="/producao" replace />} />
            <Route path="/comercial" element={<Comercial />} />
            <Route path="/financeiro" element={<Financeiro />} />
            <Route path="/equipe" element={<Navigate to="/configuracoes?tab=equipe" replace />} />
            <Route path="/configuracoes" element={<Configuracoes />} />
          </Route>
          <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </Router>
        <AppToaster />
      </AuthProvider>
    </ThemeProvider>
  );
}
